/* eslint-disable no-unused-vars */
import { axios } from './index'

const resource = '/v1/stay'

export default {

  getSubsidyCouponList(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/sbsd/available`, {params}).then(
        (res) => {
          resolve(res.data?.availableDataList || [])
        },
        (error) => {
          reject(error)
        }
      )
    })
  },

  validateUseCoupon(data) {
    // {
    //   "reservationInfo": [
    //     {
    //       "subsidyId": "string",
    //       "customerNo": "string",
    //       "subsidyDetailId": "string",
    //       "priceId": "string",
    //       "personAccompanyFlag": "string",
    //       "minimamTargetAge": 0,
    //       "degreeCount": "string",
    //       "useScheduleDateTime": "string",
    //       "acptDtlNo": "string",
    //       "company_cd": "string",
    //       "subscription_id": 0,
    //       "relationshipCd": "string",
    //       "couponId": "string"
    //     }
    //   ],
    //   "applyTargetAmount": 0
    // }
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/sbsd/available/check`, data).then(
        () => {
          resolve({
            result: 'ok',
            errorCode: '',
            errorMessage: ''
          })
        },
        (error) => {
          // resolve({
          //   result: 'ok',
          //   errorCode: '',
          //   errorMessage: ''
          // })
          reject(error)
        }
      )
    })
  },
  
  getStationMapping(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/mapping`, {params}).then(
        (res) => { resolve(res.data) },
        (error) => { reject(error?.data) }
      )
    })
  },

  getIcons(params) {
    return axios.post(`${resource}/mapping/icons`, params);
  },

  getSubsidySettingBasicList(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/sbsd/setting/basic`, {params}).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error.data)
        }
      )
    })
  },
}